import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    Skeleton,
    Typography,
    useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
    AccountBalanceWalletRounded,
    CardGiftcardRounded,
} from "@mui/icons-material";
import { Report_corporateSummary } from "../../../network/api/report.api";
import { toPriceWithComma } from "../../../helper/utils";

const _DashSummaryCards = ({ corporateId }) => {
    const theme = useTheme();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!corporateId) return;
        setLoading(true);
        Report_corporateSummary(corporateId)
            .then((res) => {
                setData(res?.data?.Data || null);
            })
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [corporateId]);

    const cards = [
        {
            title: "مانده کیف پول سازمان",
            value: data ? `${toPriceWithComma(data.WalletBalance)} تومان` : "۰ تومان",
            caption: "موجودی قابل تخصیص",
            icon: <AccountBalanceWalletRounded sx={{ fontSize: 24 }} />,
            color: "primary.main",
            bg: "rgba(45, 107, 226, 0.1)",
        },
        {
            title: "اعتبار فعال پرسنل",
            value: data ? `${toPriceWithComma(data.ActiveCreditAmount)} تومان` : "۰ تومان",
            caption: `مانده: ${data ? toPriceWithComma(data.RemainingCreditAmount) : 0} تومان`,
            icon: <CardGiftcardRounded sx={{ fontSize: 24 }} />,
            color: "success.main",
            bg: "rgba(46, 125, 50, 0.1)",
        },
    ];

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2.5}>
                {cards.map((c, idx) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={idx}>
                        <Card
                            elevation={0}
                            sx={{
                                p: 2.5,
                                height: '100%',
                                borderRadius: 3.5,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    borderColor: c.color,
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
                                },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.secondary', fontSize: '0.9rem' }}>
                                    {c.title}
                                </Typography>
                                <Box
                                    sx={{
                                        width: 42,
                                        height: 42,
                                        borderRadius: 2.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: c.bg,
                                        color: c.color,
                                    }}
                                >
                                    {c.icon}
                                </Box>
                            </Box>

                            {loading ? (
                                <Skeleton variant="text" width="60%" height={38} />
                            ) : (
                                <Typography variant="h5" sx={{ fontWeight: 900, fontSize: '1.4rem', mb: 0.6, color: 'text.primary' }}>
                                    {c.value}
                                </Typography>
                            )}

                            {loading ? (
                                <Skeleton variant="text" width="40%" height={20} />
                            ) : (
                                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.8rem', fontWeight: 600 }}>
                                    {c.caption}
                                </Typography>
                            )}
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default _DashSummaryCards;
